import * as React from 'react';
import { FC } from 'react';
import type { Game } from 'app/CasinoGames/types';
import { translateHtmlEntities } from 'app/helpers/strings';
import { buildGamesPath } from '../../gamesFacetPath';
import Cashback from './Cashback';

// Links to the vendor's provider facet page (/games/provider/:slug), which lists its games.
const Vendor: FC<{ game: Game }> = ({ game }) => (
  <a className="xo-game-details_vendor" href={buildGamesPath({ provider: game.vendorSlug })}>
    {game.vendor}
  </a>
);

const Details: FC<{
  game: Game;
  cashbackEnabled: boolean;
}> = ({ game, cashbackEnabled }) => (
  <div>
    {cashbackEnabled && <Cashback />}
    <div className="xo-game-details">
      <div>
        {/* The game page's heading - its only h1, as the grid (with its own h1) isn't rendered there. */}
        <h1 className="xo-game-details_name">{translateHtmlEntities(game.gameLocaleName)}</h1>
      </div>
      <div>
        <Vendor game={game} />
      </div>
    </div>
  </div>
);

export default Details;
